import * as React from 'react';
import PropTypes from "prop-types";
import _ from "lodash";
import {FormGroup, Label, Col, FormFeedback, Input, Alert} from "reactstrap";
import Select from "react-select";
import AdmissionFromDocumentTypeSelect from "./components/AdmissionFromDocumentTypeSelect";
import {useTranslation} from "react-i18next";

const filie = {
  'P': 'BRNO',
  'I': 'Bielsko-Biała',
  'F': 'Białystok',
  'N': 'Bydgoszcz',
  '3': 'Bytom',
  'B': 'Częstochowa',
  'U': 'Gdańsk',
  'S': 'HUB Koluszki',
  '9': 'Katowice',
  'D': 'Kraków',
  'V': 'Lublin',
  'A': 'Łódź',
  'W': 'Nitra',
  '1': 'Opole',
  'O': 'Ostrava',
  '8': 'Poznań',
  'R': 'PRESOV',
  'H': 'Rzeszów',
  'K': 'Radom',
  'L': 'Sviadnov',
  'T': 'Szczecin',
  'G': 'Warszawa 1',
  'J': 'Warszawa 2',
  'X': 'Warszawa 3',
  '4': 'Wieliczka',
  '2': 'Wrocław 1',
  'M': 'Wrocław 2 (Psary)',
  'C': 'Zielona Góra',
}
const options = _.map(filie, (label, value) => ({
  label,
  value,
}));

const HartFiliaSelect = (props) => {
  const [value, setValue] = React.useState(props.value);

  return <Select
    classNamePrefix="react-select"
    options={options}
    value={options.find(o => o.value === value)}
    placeholder="Wybierz swoją filę..."
    onChange={option => {
      setValue(option.value);
      props.onChange(option.value);
    }}
  />
}

function SupplierHartFields(props) {
  const { t } = useTranslation('supplier_create')

  return (
    <React.Fragment>
      <Alert color={'info'}>
        <span>{t('supplier.hart.hint')}</span>
      </Alert>
      <FormGroup row>
        <Label md={3}>{t('supplier.hart.filia')}</Label>
        <Col md="9">
          <HartFiliaSelect
            value={props.data.filia}
            onChange={filia => props.onChangeData({filia})}
          />
          <FormFeedback>{props.errors.filia?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier._global.client_id')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.clientId?.errors} placeholder={t('supplier._global.client_id')} onChange={e => props.onChangeData({clientId: e.target.value})} value={props.data.clientId || ''} />
          <FormFeedback>{props.errors.clientId?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier._global.password')}</Label>
        <Col md="9">
          <Input invalid={!!props.errors.password?.errors} placeholder={t('supplier._global.password')} onChange={e => props.onChangeData({password: e.target.value})} value={props.data.password || ''} />
          <FormFeedback>{props.errors.password?.errors?.join('; ')}</FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={3}>{t('supplier.hart.admission_from_document_type')}</Label>
        <Col md="9">
          <AdmissionFromDocumentTypeSelect
            isDisabled={!!props.data.id}
            value={props.data.admissionFromDocumentType}
            onChange={admissionFromDocumentType => props.onChangeData({admissionFromDocumentType})}
          />
          {!!props.errors.admissionFromDocumentType?.errors && <FormFeedback className="d-block">{props.errors.admissionFromDocumentType?.errors?.join('; ')}</FormFeedback>}
        </Col>
      </FormGroup>
    </React.Fragment>
  );
}

SupplierHartFields.propTypes = {
  onChangeData: PropTypes.func.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    clientId: PropTypes.string,
    password: PropTypes.string,
    filia: PropTypes.string,
    admissionFromDocumentType: PropTypes.string,
  }).isRequired,
  errors: PropTypes.object.isRequired,
};

export default SupplierHartFields;
